import { render, staticRenderFns } from "./LoginInfoContainerFooter.vue?vue&type=template&id=f406e148&"
import script from "./LoginInfoContainerFooter.vue?vue&type=script&lang=js&"
export * from "./LoginInfoContainerFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports